const imageCompressOptions = {
  maxSizeMB: 0.2,
  // maxWidthOrHeight: 500,
  maxIteration: 10,
  useWebWorker: true,
};

const imgMaxCount = 5;
export { imageCompressOptions, imgMaxCount };
